import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSourceSystem } from "../../../hooks/useSourceSystem";
import { getLocalStorage } from "../../../sessionAndLocalStorage";
import {
  getAppraisalData,
  getRegistrationInput
} from "../../../store/selectors";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import { HPIRegCheck } from "../../helpers";
import { useNavigate } from "react-router-dom";

export function useCheckRegistration() {
  const { sourceSystem } = useSourceSystem();
  const regInput: string = useSelector(getRegistrationInput);
  const [reg, setReg] = useState<string>(regInput);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { vehicleNotFoundError } = sourceSystem;
  const {
    errorMain,
    errorHint,
    primaryButtonText,
    secondaryButtonText,
    showAltButton
  } = vehicleNotFoundError.vehicleNotFoundErrorContent;

  const { appraisalSessionId }: { appraisalSessionId: string } = useSelector(
    getAppraisalData
  );

  const hasLettersAndNumbers: RegExp = new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])");

  const handleSubmit = () => {
    dispatch(appraisalSlice.actions.clearError());
    dispatch(appraisalSlice.actions.setRegistrationInput(reg));

    const regWithoutSpaces = reg.replace(/\s/g, "");
    if (
      hasLettersAndNumbers.test(regWithoutSpaces) &&
      HPIRegCheck.test(regWithoutSpaces)
    ) {
      const data = getLocalStorage(`_abyc_authToken_${appraisalSessionId}`);
      navigate(
        `/mileage?registration=${regWithoutSpaces}&appraisalSessionId=${appraisalSessionId}&data=${data}`
      );
    } else {
      setError("Enter a valid registration number");
    }
  };

  const handleRegChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReg(e.target.value);
  };

  return {
    error,
    errorMain,
    errorHint,
    primaryButtonText,
    secondaryButtonText,
    appraisalSessionId,
    handleSubmit,
    handleRegChange,
    regInput,
    sourceSystem,
    showAltButton
  };
}
